<!--
 * @Descripttion:
 * @version: 0.0.1
 * @Author: ZHJI
 * @Date: 2019-09-25 09:23:56
 * @LastEditors: ZHJI
 * @LastEditTime: 2019-11-21 10:40:17
 -->
<!--  -->
<template>
<basicContainer>
    <div class="announcementManage">
        <!-- 主数据表 -->
        <easyCruds ref="mainTable" :tableInfo="mainTable"
                  @mainTableReload="mainTableReload"
                  @editRow="editRow"
                  @beforeEditFunctionName="beforeEditFunctionName"
                  @cplbChange="cplbChange">
        </easyCruds>

    </div>
    </basicContainer>
</template>

<script>

export default {
  components: {
    

  },
  data() {
    return {
        status:'',
      mainTable: {
        editText:'提名',
        buttonSetting: { 
          allowAdd: false,
          allowEdit: true,
            beforeEditFunctionName: 'beforeEditFunctionName',
            editButtonArray:[{
                clickEvent:'editRow',
                type:'primary',
                buttonName:'保存编辑',
                validate: true
            }],
          allowDelete: false,
          allowView: true,
          left: [],
          right: []
        },
        header: {
          title: '奖学金提名管理'
        },
        table: {
          loading: false,
          height: 550,
          stripe: true,
          conditionLabelWidth: 'auto',
          selection: false,
          index: false,
          columns: [{
            prop: 'id',
            label: 'ID',
            showInTable:false,
            isSearchCondition: false,
            type: 'input',
            span: 12,
            disabled: [true, true, true],
            view:[false, false, false],
            dicData: []
          },{
            prop: 'xh',
            label: '学号',
            isSearchCondition: true,
            type: 'input',
            span: 12,
            disabled: [true, true, true],
            dicData: []
          }, {
            prop: 'xm',
            label: '姓名',
            isSearchCondition: true,
            type: 'input',
            rows: 5,
            span: 12,
            disabled: [true, true, true]
          },{
              prop: 'cplb',
              label: '奖学金类别',
              isSearchCondition: true,
              type: 'select',
              showInTable:false,
              rows: 5,
              span: 12,
              searchChangeFunction: 'cplbChange',//原学院触发事件
              disabled: [true, true, true],
              view:[false, false, false]
          }, {
            prop: 'applicationName',
            label: '奖学金名称',
            isSearchCondition: true,
            type: 'select',
            span: 12,
            width: '150',
            disabled: [true, true, true]
          },{
              prop: 'applicationXn',
              label: '申请学年',
              isSearchCondition: true,
              showInTable: false,
              type: 'select',
              span: 12,
              disabled: [true, true, true]
          }, {
              prop: 'cpdjName',
              label: '奖学金等级',
              isSearchCondition: false,
              type: 'input',
              span: 12,
              width: '150',
              disabled: [true, true, true]
          }, {
              prop: 'applicationMoney',
              label: '奖学金金额',
              isSearchCondition: false,
              type: 'input',
              span:12,
              width: 170,
              disabled: [true, true, true]
          }, {
              prop: 'notPassReason',
              label: '不满足条件',
              isSearchCondition: false,
              type: 'textarea',
              span: 24,
              width: '150',
              disabled: [true, true, true]
          }, {
              prop: 'status',
              label: '通过状态',
              isSearchCondition: true,
              type: 'select',
              isTag: true,
              span: 12,
              required: true,
              dicData: [{
                  label:'已通过',
                  value:1
              },
              {
                  label:'未通过',
                  value:0
              }],
              tagFilter: function(e) {
              if (e === '1') {
                return {
                  data: '已通过'
                }
              } else if (e === '0') {
                return {
                  data: '未通过' 
                }
              }
            },
              disabled: [true, true, false]
          }, {
              prop: 'passReason',
              label: '通过原因',
              isSearchCondition: false,
              type: 'textarea',
              span: 24,
              required: true,
              disabled: [true, true, false]
          }],
          operation: {
            width: '220',
            operations: []
          },
          tableData: [],
          paging: {
            currentPage: 1,
            pageSizes: [10, 15, 20, 25],
            pageSize: 10,
            total: 0
          },
          reload: 'mainTableReload',
          reloadConditions: {},
          addDefultValue: {}
        }

      },

    }
  },

  mounted() {
        /* 列表渲染*/
        this.mainTableReload({ pageNum: 1, pageSize: 10 })
        /*申请学年*/
        this.getXN()

      //奖学金类别名称
      this.getLBMC()
  },
  methods: { 
    mainTableReload: function(params) { 
      this.mainTable.table.loading = true
      this.$http.get('/nomination/query', {
        params
      }).then(
        response => {
          this.mainTable.table.loading = false
          // 成功之后的数据
          this.mainTable.table.tableData = response.data.records
          this.mainTable.table.paging.total = response.data.total || response.data.records.length
          return true
        }
      ).catch(
        error => {
          this.mainTable.table.loading = false
          this.$message.error(error.msg)
        }
      )
    },
      beforeEditFunctionName: function(row, type, callback) {
          delete row.passReason
          delete row.status
          callback(row);

      },
    editRow: function(row, done, errorDone,note,setting,oldData){
      let params = {
        id: row.id,
        passReason: row.passReason,
        status: row.status
      }
       this.$http.post('/nomination/update',null, {params}).then(response => {  
            this.$message.success('更新成功') && done()
            this.mainTableReload(this.$refs.mainTable.getReloadConditions())

        }).catch(error => {
            this.$message.error(error.msg) && errorDone()
        })
    },
      sortBy: function(attr,rev){
          //第二个参数没有传递 默认升序排列
          if(rev ==  undefined){
              rev = 1;
          }else{
              rev = (rev) ? 1 : -1;
          }

          return function(a,b){
              a = a[attr];
              b = b[attr];
              if(a < b){
                  return rev * -1;
              }
              if(a > b){
                  return rev * 1;
              }
              return 0;
          }
      },
      getXN:function () {
          this.$http.get('/Xn/queryMap').then(response => {
              let result = []
              response.data.forEach(element => {
                  result.push({
                      label: element.xnd,
                      value: element.id
                  })
              })
              result=result.sort(this.sortBy('label',false));
              this.$refs.mainTable.setColumnSeting('applicationXn', 'dicData', result)

          }).catch(error => {
              this.$message.error(error.msg)
          })

      },
      getLBMC:function () {
          this.$http.get('/cplb/list').then(response => {
              let result = []
              response.data.forEach(element => {
                  result.push({
                      label: element.lbmc,
                      value: element.id
                  })
              })
              this.$refs.mainTable.setColumnSeting('cplb', 'dicData', result)

          }).catch(error => {
              this.$message.error(error.msg)
          })

      },
      cplbChange: function(val, data, callback){
          if (!val.value && !callback) {
              (data.yzy = data.ybj = '')
              return
          } else if (!val.value && callback) {
              typeof callback === 'function' && callback([])
          }
          this.$http.get('/cpxx/list', {params:{
                  cpdl_id:val.value
              }}).then(response => {
              let result = []
              response.data.forEach(element => {
                  result.push({
                      label: element.cp_mc,
                      value: element.id
                  })
              })

              if (callback) {
                  typeof callback === 'function' && callback(result)
              } else {
                  this.$refs.mainTable.setColumnSeting('applicationName', 'dicData', result)

                  let that = this
                  that.mainTable.table.reloadConditions.applicationName = ''
              }
          }).catch(error => {
              this.$message.error(error.msg)
          })
      },
  }
}
</script>

<style lang='scss'>

    .quill-editor {
        height: 300px;
    }

</style>
<style lang='scss' scoped>
    .file {
        z-index: 999;
        opacity: 0;
        position: absolute;
        left: 2px;
        width: 140px;
        cursor: pointer;
        height: 44px;
    }
    .file_btn {
        position: absolute;
        left: 2px;
        width: auto;
        z-index: 0;
    }
</style>
